import { renderRowGaps, renderSectionHeader, renderPercentRow, renderMainLeftCell, renderSoftLeftCell } from '../helpers';
import { textBold } from '../download-data-styles';

export const renderGeographicBreakdownHeaderRow = (header, asOfDate) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(header, textBold);
  rowString += renderSoftLeftCell(asOfDate);
  rowString += `</tr>`;
  return rowString;
};

export const geographicBreakdownModule = data => {
  let moduleString = ``;
  moduleString += renderSectionHeader('Geographic Breakdown');
  moduleString += renderRowGaps();
  if (data.regionsData.length) {
    moduleString += renderRowGaps(2);
    moduleString += renderGeographicBreakdownHeaderRow('Regions', `% of net assets as of ${data.regionsDate} (updated monthly)`);
    moduleString += renderRowGaps();
    data.regionsData.forEach(region => {
      moduleString += renderPercentRow(region.label, region.DataValue);
    });
  }
  if (data.countriesData.length) {
    moduleString += renderRowGaps(2);
    moduleString += renderGeographicBreakdownHeaderRow('Top Countries', `% of net assets as of ${data.countriesDate} (updated monthly)`);
    moduleString += renderRowGaps();
    data.countriesData.forEach(country => {
      moduleString += renderPercentRow(country.ValueDescription, country.DataValue);
    });
  }
  moduleString += renderRowGaps(2);
  return moduleString;
};
